<template>
  <div :id="$route.name">
    <!-- <div class="row mb-4" v-if="$route.params.Status != 'Edit' && $route.params.Status != 'Product'">
            <div class="col-md-4 col-12"></div>
            <div class="col-md-3 col-12">
                <div class="btn btn-success w-100 Pointer" @click="IsRasmi=true" v-if="!IsRasmi"> ثبت قرارداد جدید </div>
                <div class="btn btn-warning w-100 Pointer"  @click="IsRasmi=false" v-if="IsRasmi"> فروش محصول جدید </div>
            </div>
            
            <div class="col-md-4 col-12"></div>
        </div> -->

    <Card back v-if="IsRasmi">
      <template v-slot:header>
        <h4 class="d-inline">
          {{
            $route.params.Status == "Edit" ? "ویرایش قرارداد" : "ثـبت قـراداد "
          }}
        </h4>
        <button
          class="btn btn-warning float-left"
          @click="ToCustomer"
          v-if="tempFactoToContract"
        >
          بازگشت به مشتری
        </button>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row" id="DivContract">
          <div class="mb-3 mr-3">
            <a
              v-if="AddModeContract == 0"
              class="d-inline float-right mx-2 mt-1"
              href="javascript:;"
              @click="
                AddModeContract = 1;
                AddModeProduct = 0;
              "
              data-title="افزودن محصول جدید"
            >
              <h4>
                <i
                  class="fas fa-plus text-success"
                  style="color: var(--logo-color) !important"
                ></i>
              </h4>
            </a>
            <a
              v-if="AddModeContract != 0"
              class="d-inline float-right mx-2 mt-1"
              href="javascript:;"
              @click="AddModeContract = 0"
              title="لغو افزودن"
            >
              <h4><i class="fas fa-times text-danger"></i></h4>
            </a>
          </div>
          <div class="col-12" v-if="AddModeContract != 0" id="ContractRow">
            <div class="row">
              <div class="col-md-3 col-12">
                <small id="LblTblCostomer">مربوط به مشتری</small>

                <SearchableCombo
                  :edit="false"
                  :grp="0"
                  :code="null"
                  @ResultCombo="GetResulTblCostomer"
                  :rownumintable="3"
                  :defaultvalue="DataAxios.TblCustomerId"
                  :action="'TblCrmCombo/GetCostomerProduct'"
                  :method="'POST'"
                  :idinput="'TblCostomer'"
                  :keyItem="'TblCostomer'"
                  :disabled="$route.params.Status == 'Edit' || Disable == true"
                  :ClassProps="'required'"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-3 col-12">
                <small id="LblContractStartDate"> تاریخ شروع</small>
                <date-picker
                  color="dimgray"
                  input-class="required form-control"
                  v-model="DataAxios.ContractStartDate"
                  clearable
                  :editable="true"
                  placeholder="تاریخ شروع"
                ></date-picker>
              </div>
              <div class="col-md-3 col-12">
                <small id="LblContractEndDate"> تاریخ پایان</small>
                <date-picker
                  color="dimgray"
                  input-class="required form-control"
                  v-model="DataAxios.ContractEndDate"
                  clearable
                  :editable="true"
                  placeholder="تاریخ پایان"
                ></date-picker>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 col-12">
                <small id="LblAmount">مبلغ قرارداد</small>

                <input
                  dir="ltr"
                  :disabled="$route.params.Status == 'Edit' || Disable == true"
                  :class="
                    $route.params.Status == 'Edit' || Disable == true
                      ? 'no-drop'
                      : ''
                  "
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  @keyup="DataAxios.Amount = $PutCommatoInput_New($event)"
                  class="form-control InputText 3ragham text-success required"
                  id="txtAmount"
                  @input="CheckLenghtDiscount()"
                  v-model="DataAxios.Amount"
                  tabindex="2"
                />
              </div>
              <div class="col-md-3 col-12">
                <small id="LblDiscount">مبلغ تخفیف</small>
                <input
                  dir="ltr"
                  :disabled="$route.params.Status == 'Edit' || Disable == true"
                  :class="
                    $route.params.Status == 'Edit' || Disable == true
                      ? 'no-drop'
                      : ''
                  "
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  @keyup="
                    DataAxios.Discount = $PutCommatoInput_New($event);
                    FocusOutAmount($event);
                  "
                  @blur="CheckLenghtDiscount($event, false)"
                  class="form-control InputText 3ragham text-success"
                  id="txtDiscount"
                  v-model="DataAxios.Discount"
                  tabindex="3"
                />
              </div>
              <div class="col-md-3 col-12">
                <small id="LblTax">مبلغ مالیات </small>
                <input
                  dir="ltr"
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  @keyup="DataAxios.Tax = $PutCommatoInput_New($event)"
                  class="form-control required no-drop"
                  id="txtTax"
                  v-model="DataAxios.Tax"
                  tabindex="4"
                  disabled
                />
              </div>
              <div class="col-md-3 col-12">
                <small id="LblToll">مبلغ عوارض </small>
                <input
                  dir="ltr"
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  @keyup="DataAxios.Toll = $PutCommatoInput_New($event)"
                  class="form-control required no-drop"
                  id="txtToll"
                  v-model="DataAxios.Toll"
                  tabindex="5"
                  disabled
                />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-9">
                <small id="Lblinfodes">توضیحات قرارداد</small>
                <textarea
                  class="form-control"
                  rows="1"
                  v-model="DataAxios.infodes"
                ></textarea>
              </div>
              <div class="col-md-3">
                <small id="LblTotallAmount">مبلغ کل قراداد </small>
                <input
                  dir="ltr"
                  type="text"
                  class="form-control required no-drop"
                  id="txtTotallAmount"
                  v-model="DataAxios.TotallAmount"
                  tabindex="5"
                  disabled
                />
                <div class="">
                  <small class="text-muted"
                    >{{ Mab2persian }}{{ " ريال " }}</small
                  >
                </div>
                <div class="">
                  <button
                    v-if="$route.params.Status != 'Edit'"
                    @click="SetContrctAndProducts"
                    class="btn-success btn w-100 mt-2"
                  >
                    ثبت قرارداد
                  </button>
                </div>
              </div>
              <div
                class="col-md-3 col-12"
                v-if="
                  $route.params.Status == 'Edit' &&
                  $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245
                "
              >
                <small id="LblIsApproval">وضــعیت تایید مدیر</small>
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="Archive"
                      v-model="DataAxios.IsApproval"
                    />
                    <label class="custom-control-label" for="Archive"
                      >وضــعیت تایید مدیر</label
                    >
                  </div>
                </span>
              </div>
              <!-- <div class="col-md-3 col-12">
                <small id="LblNeedSubmit">نیاز به تمدید</small>
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input InputText" id="NeedSubmit" v-model="DataAxios.NeedSubmit" />
                    <label class="custom-control-label" for="NeedSubmit">نیاز به تمدید</label>
                  </div>
                </span>
              </div> -->
            </div>
            <div class="row mt-2">
              <div class="col-12"></div>
            </div>
            <!-- <btn-save-data v-if="$route.params.Status!='Edit'" :DataParanet="DataAxios"  @Success="AddSuccess"></btn-save-data> -->
            <btn-edit-data
              v-if="$route.params.Status == 'Edit'"
              :DataParanet="DataAxios"
            ></btn-edit-data>
          </div>
        </div>
      </template>
    </Card>

    <Card back v-if="Status == 'Product'">
      <template v-slot:header>
        <!-- <h5><i class="fad fa-arrow-right text-secondary Pointer" @click="GotoContract(ContractParent.TblCustomerId)"></i></h5> -->
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-6 col-12">
            <span class="text-warning" style="font-size: 25px">قرارداد</span>
            <h5>{{ ContractParent.CustomerName }}</h5>
          </div>
          <div class="col-md-3 col-12 text-right">
            <div class="mt-1">
              نوع قرارداد : <span>{{ ContractParent.NameGrpId12 }}</span>
            </div>
            <div class="mt-1">
              وضعیت قرارداد : {{ ContractParent.NameGrpId39 }}
            </div>
            <div class="mt-1">
              {{ ContractParent.ContractStartDate }} ----
              {{ ContractParent.ContractEndDate }}
            </div>
          </div>
          <div class="col-md-3 col-12 text-center">
            <div class="mt-1">
              مبلغ قرارداد : {{ $Comma3ragham(ContractParent.Amount) }} ریال
            </div>
            <div class="mt-1">
              مبلغ تخفیف : {{ $Comma3ragham(ContractParent.Discount) }} ریال
            </div>
            <div class="mt-1 text-center">
              <span class="text-warning" style="font-size: 20px">{{
                $Comma3ragham(ContractParent.TotallAmount)
              }}</span>
            </div>
            <div class="mt-1 text-center">
              <!-- <span v-if="Detail.Remember>0" class="text-danger">{{$Comma3ragham(Detail.Remember)}} بدهکار</span> -->
            </div>
            <!-- <div class="mt-1 text-center">
              <div class="rubber_stamp" v-if="Detail.Remember == 0">تسویه شد</div>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <BnpGrid
              v-if="$store.state.renderComponentGrid"
              :hasRowNum="true"
              :propsColumn="Column"
              :propsRows="rows"
              :action="true"
            >
              <template slot="action-slot" slot-scope="props">
                <a
                  href="javascript:;"
                  class="mr-2 badge"
                  v-if="
                    IsAccessDelete || $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245
                  "
                  @click="OnEditProduct(props.props)"
                  data-title="ویرایش"
                  ><h5>
                    <span class="fa fa-pencil-square-o hover-info"></span></h5
                ></a>
                <a
                  href="javascript:;"
                  class="mr-2 badge"
                  v-if="
                    IsAccessDelete || $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245
                  "
                  @click="OnDeleteProduct(props.props)"
                  data-title="حذف"
                  ><h5><span class="fad fa-trash hover-danger"></span></h5
                ></a>
              </template>
              <template slot="MetaSlot" slot-scope="props">
                <button
                  class="btn btn-primary text-center mb-2"
                  dir="ltr"
                  v-if="IsAccessSetDeposit"
                  @click.prevent="SetDeposit(props.props)"
                >
                  ثبت واریز <span class="fad fa-plus mx-2"></span>
                </button>
              </template>
              <template slot="TotallAmount" slot-scope="props">
                <span>{{
                  $Comma3ragham(Math.floor(props.props.TotallAmount))
                }}</span>
              </template>
              <template slot="Discount" slot-scope="props">
                <span>{{
                  $Comma3ragham(Math.floor(props.props.Discount))
                }}</span>
              </template>
              <template slot="Amount" slot-scope="props">
                <span>{{ $Comma3ragham(Math.floor(props.props.Amount)) }}</span>
              </template>
              <template slot="Tax" slot-scope="props">
                <span>{{
                  $Comma3ragham(
                    Math.floor(
                      Number(props.props.Toll) + Number(props.props.Tax)
                    )
                  )
                }}</span>
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>

    <Card back v-if="!IsRasmi && Status != 'Product'">
      <template v-slot:header>
        <div class="" v-if="$route.params.Status == 'Product'">
          <h4 class="d-inline">ثـبت محـصول</h4>
          : <span class="text-warning">{{ ContractParent.CustomerName }}</span>
        </div>
        <div class="" v-else>
          <h4 class="d-inline">ثـبت محـصول</h4>
        </div>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="mb-3 mr-3">
            <a
              v-if="AddModeProduct == 0"
              class="d-inline float-right mx-2 mt-1"
              href="javascript:;"
              @click="
                AddModeProduct = 1;
                AddModeContract = 0;
              "
              data-title="افزودن قرارداد جدید"
            >
              <h4>
                <i
                  class="fas fa-plus text-success"
                  style="color: var(--logo-color) !important"
                ></i>
              </h4>
            </a>
            <a
              v-if="AddModeProduct != 0"
              class="d-inline float-right mx-2 mt-1"
              href="javascript:;"
              @click="
                AddModeProduct = 0;
                ReloadProduct();
              "
              data-title="لغو افزودن"
            >
              <h4><i class="fas fa-times text-danger"></i></h4>
            </a>
          </div>
          <div class="col-12 text-danger">
            {{ ErrList[0] }}
          </div>
          <div
            class="col-12"
            v-if="AddModeProduct != 0"
            id="DetailCustomerProductRow"
          >
            <div class="row">
              <div class="col-md-6 col-12">
                <small id="LblTblCostomer">مربوط به مشتری</small>
                <SearchableCombo
                  :edit="false"
                  :grp="0"
                  :code="null"
                  @ResultCombo="GetResulTblCostomerProduct"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosProduct.TblCustomerId"
                  :action="'TblCrmCombo/GetCostomerProduct'"
                  :method="'POST'"
                  :idinput="'TblCostomer'"
                  :keyItem="'TblCostomer'"
                  :disabled="
                    listProduct.length > 0 ||
                    TblContract != null ||
                    DataAxiosProduct.TblCustomerId
                  "
                  :ClassProps="'required'"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-3 col-12">
                <small id="LblTblProductsId">محصول</small>
                <SearchableCombo
                  :edit="false"
                  :grp="0"
                  :code="null"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosProduct.TblProductsId"
                  @ResultCombo="GetResulTblProductsId"
                  :action="'TblCrmCombo/GetProduct'"
                  :method="'POST'"
                  :idinput="'TblProductsId'"
                  :keyItem="'TblProductsId'"
                  :disabled="false"
                  :ClassProps="'required'"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-2 col-12">
                <small id="LblCount">تعداد</small>
                <input
                  dir="ltr"
                  type="number"
                  @keypress="$ValidNumber($event, 2)"
                  @input="FocusOutAmountProduct()"
                  class="form-control"
                  id="txtCount"
                  v-model="DataAxiosProduct.Count"
                  tabindex="1"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 col-12">
                <small id="LblAmount">مبلغ</small>
                <input
                  dir="ltr"
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  @input="FocusOutAmountProduct()"
                  @keyup="
                    DataAxiosProduct.Amount = $PutCommatoInput_New($event)
                  "
                  class="form-control InputText 3ragham required"
                  id="txtAmount"
                  v-model="DataAxiosProduct.Amount"
                  tabindex="2"
                />
              </div>
              <div class="col-md-3 col-12">
                <small id="LblDiscount">مبلغ تخفیف</small>
                <input
                  dir="ltr"
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  @keyup="
                    DataAxiosProduct.Discount = $PutCommatoInput_New($event)
                  "
                  @input="FocusOutAmountProduct($event)"
                  class="form-control InputText 3ragham required"
                  id="txtDiscount"
                  v-model="DataAxiosProduct.Discount"
                  tabindex="3"
                />
              </div>
              <div class="col-md-3 col-12">
                <small id="LblTax">مبلغ مالیات </small>

                <input
                  dir="ltr"
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  class="form-control"
                  id="txtTax"
                  v-model="DataAxiosProduct.Tax"
                  tabindex="4"
                  disabled
                />
              </div>
              <div class="col-md-3 col-12">
                <small id="LblToll">مبلغ عوارض </small>
                <input
                  dir="ltr"
                  type="text"
                  @keypress="$ValidNumber($event, 15)"
                  class="form-control"
                  id="txtToll"
                  v-model="DataAxiosProduct.Toll"
                  tabindex="5"
                  disabled
                />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-9">
                <small id="LblNeedSubmit">نیاز به تمدید</small>
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="NeedSubmit"
                      v-model="DataAxiosProduct.NeedSubmit"
                    />
                    <label class="custom-control-label mr-2" for="NeedSubmit">
                      نیاز به تمدید
                    </label>
                  </div>
                </span>
              </div>
              <div class="col-md-3">
                <small id="LblToll">مبلغ کل </small>
                <input
                  dir="ltr"
                  type="text"
                  class="form-control"
                  id="txtTotallAmount"
                  v-model="DataAxiosProduct.TotallAmount"
                  tabindex="5"
                  disabled
                />
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12">
                <hr />
                <button
                  class="btn btn-success float-right mr-5"
                  v-if="ErrList.length == 0"
                  @click.prevent="AddRow(false)"
                  data-title="ردیف جدید"
                >
                  ثبت اطلاعات
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>

    <Card v-if="listProduct.length > 0">
      <template v-slot:content>
        <div class="row">
          <div
            class="col-md-3 col-12"
            v-for="(item, index) in listProduct"
            :key="index"
          >
            <CardBox>
              <template v-slot:cardbox-icon1>
                <i class="fas fa-gift"></i>
              </template>
              <template v-slot:b-dropdown-item>
                <b-dropdown-item
                  @click="DeleteProduct(item.TblProductsId)"
                  href="#"
                  class="text-center"
                  >حذف</b-dropdown-item
                >
              </template>
              <template v-slot:cardbox-body>
                <p class="card-text detail font-weight-bold">
                  {{ item.ProductName }}
                </p>
                <p class="card-text detail">
                  {{
                    TblContract && TblContract != null
                      ? ContractParent.CustomerName
                      : ""
                  }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-coins d-none"></i> مبلغ واحد :
                  {{ $Comma3ragham(item.Amount) }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-coins d-none"></i> تعداد :
                  {{ item.Count }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-coins d-none"></i> مبلغ بدون مالیات و تخفیف :
                  {{
                    $Comma3ragham(item.Amount.replace(/,/g, "") * item.Count)
                  }}
                </p>
                <hr />
                <p class="card-text detail">
                  <i class="fas fa-percent d-none"></i> تخفیف :
                  {{ $Comma3ragham(item.Discount) }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-cash-register d-none"></i> مالیات :
                  {{ $Comma3ragham(item.Tax) }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-cash-register d-none"></i> عوارض :
                  {{ $Comma3ragham(item.Toll) }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-sack-dollar d-none"></i> مبغ کل :
                  {{ $Comma3ragham(item.TotallAmount) }}
                </p>
              </template>
            </CardBox>
          </div>
        </div>
        <div class="row mt-2" v-if="!tempFactoToContract">
          <div class="col-md-3"></div>
          <div class="col-md-3"></div>
          <div class="col-md-3"></div>
          <div class="col-md-3 col-12">
            <!-- v-if="!IsRasmi" this is a Not  Please Dont Remove Not-->
            <button
              @click="submitProductContract(true)"
              class="btn-success btn w-100"
            >
              تایید نهایی
            </button>
            <!-- Method: SubmitProduct  -->
            <button
              v-if="IsAccess('btnSetContract!Rasmi')"
              @click="submitProductContract(false)"
              class="btn-success btn w-100 mt-2"
            >
              ثبت محصول F3
            </button>
          </div>
        </div>
      </template>
    </Card>

    <!-- مدال ویرایش محصول -->
    <modal
      v-if="$store.state.Modal"
      :InheritanceTheme="true"
      :IsFooter="false"
      :Size="'Md'"
    >
      <template v-slot:body>
        <div class="p-4" id="DetailCustomerProductEdit">
          <div class="row">
            <div class="col-12 mb-3">
              <h3 style="color: var(--sidebar-color-item) !important">
                {{ NameProductForEdit }}
              </h3>
            </div>
            <div class="col-md-4 col-12">
              <small id="LblCount">تعداد</small>
              <input
                dir="ltr"
                type="number"
                @keypress="$ValidNumber($event, 2);FocusOutAmountProductEdit($event)"
                class="form-control"
                id="txtCount"
                v-model="DataAxiosEditProduct.Count"
                tabindex="1"
              />
            </div>

            <div class="col-md-4 col-12">
              <small id="LblAmount">مبلغ</small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15);FocusOutAmountProductEdit($event)"
                @keyup="
                  DataAxiosEditProduct.Amount = $PutCommatoInput_New($event)
                "
                class="form-control InputText 3ragham required"
                id="txtAmount"
                v-model="DataAxiosEditProduct.Amount"
                tabindex="2"
              />
            </div>
            <div class="col-md-4 col-12">
              <small id="LblDiscount">مبلغ تخفیف</small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15);FocusOutAmountProductEdit($event)"
                @keyup="
                  DataAxiosEditProduct.Discount = $PutCommatoInput_New($event)
                "
                class="form-control InputText 3ragham required"
                id="txtDiscount"
                v-model="DataAxiosEditProduct.Discount"
                tabindex="3"
              />
            </div>
            <div
              class="col-md-4 col-12 mt-2"
              v-if="DataAxiosEditProduct.tblComboGrpId12 != 1227"
            >
              <small id="LblTax">مبلغ مالیات </small>

              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                @keyup="DataAxiosEditProduct.Tax = $PutCommatoInput_New($event)"
                class="form-control 3ragham"
                id="txtTax"
                v-model="DataAxiosEditProduct.Tax"
                tabindex="4"
                disabled
              />
            </div>
            <div
              class="col-md-4 col-12 mt-2"
              v-if="DataAxiosEditProduct.tblComboGrpId12 != 1227"
            >
              <small id="LblToll">مبلغ عوارض </small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                @keyup="
                  DataAxiosEditProduct.Toll = $PutCommatoInput_New($event)
                "
                class="form-control 3ragham"
                id="txtToll"
                v-model="DataAxiosEditProduct.Toll"
                tabindex="5"
                disabled
              />
            </div>

            <div class="col-md-4 col-12 mt-2">
              <small id="LblNeedSubmit">نیاز به تمدید</small>
              <span class="form-control p-1">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input InputText"
                    id="NeedSubmit"
                    v-model="DataAxiosEditProduct.NeedSubmit"
                  />
                  <label class="custom-control-label mr-2" for="NeedSubmit">
                    نیاز به تمدید
                  </label>
                </div>
              </span>
            </div>

            <div class="col-md-4 col-12 mt-2">
              <small id="LblToll">مبلغ کل </small>
              <input
                dir="ltr"
                type="text"
                class="form-control 3ragham"
                id="txtTotallAmount"
                v-model="DataAxiosEditProduct.TotallAmount"
                @keyup="
                  DataAxiosEditProduct.TotallAmount =
                    $PutCommatoInput_New($event)
                "
                tabindex="5"
                disabled
              />
            </div>

            <div class="col-md-4 col-12">
              <button
                class="btn btn-primary w-100"
                v-if="ErrList.length == 0"
                @click.prevent="EditRow()"
                style="margin-top: 28px"
              >
                ویرایش اطلاعات
              </button>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer> </template>
    </modal>
  </div>
</template>
<script>
import Card from "@/components/Card/Card.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import BtnSaveData from "@/components/BnpButtons/BtnSaveData.vue";
import BtnEditData from "@/components/BnpButtons/BtnEditData.vue";
import Num2persian from "num2persian";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import CardBox from "@/components/CardBox/CardBox.vue";
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
import Modal from "../../Modal/Modal.vue";

export default {
  data() {
    return {
      ArzeshAfzode1402:0.06,
      ArzeshAfzode1403 :0.07,
      IsRasmi: false,
      ContractParent: {},
      DataAxios: {},
      DataAxiosProductnew: {
        Id: 1,
        Count: 1,
        DataAxiosProduct: 0,
        Discount: 0,
        Tax: 0,
        TotallAmount: 0,
        Toll: 0,
        NeedSubmit: false,
      },
      Disable: false,
      DataAxiosProduct: {},

      AddModeProduct: 0,
      AddModeContract: 0,

      TotallAmountProduct: 0,
      listProduct: [],
      rows: [],
      Column: [
        {
          id: 204443,
          name: "CustomerName",
          visibility: false,
          width: 0,
          indexCol: 3,
          label: "نام مشتری",
        },
        {
          id: 204446,
          name: "DateTimeInsert",
          visibility: true,
          width: 0,
          indexCol: 9,
          label: "زمان ایجاد",
        },
        {
          id: 204473,
          name: "Name",
          visibility: true,
          width: 0,
          indexCol: 9,
          label: "محصول",
        },
        {
          id: 204474,
          name: "ContractStartDate",
          visibility: true,
          width: 0,
          indexCol: 9,
          label: "شروع قرارداد",
        },
        {
          id: 204475,
          name: "ContractEndDate",
          visibility: true,
          width: 0,
          indexCol: 9,
          label: "پایان قرارداد",
        },
        {
          id: 204473,
          name: "Count",
          visibility: true,
          width: 0,
          indexCol: 15,
          label: "تعداد",
        },
        {
          id: 204467,
          name: "Amount",
          visibility: true,
          width: 0,
          indexCol: 10,
          label: "مبلغ قرارداد",
        },
        {
          id: 204469,
          name: "Tax",
          visibility: true,
          width: 0,
          indexCol: 12,
          label: "مالیات و عوارض",
        },
        {
          id: 204470,
          name: "Toll",
          visibility: false,
          width: 0,
          indexCol: 13,
          label: "عوارض",
        },
        {
          id: 204468,
          name: "Discount",
          visibility: true,
          width: 0,
          indexCol: 11,
          label: "تخفیف",
        },
        {
          id: 204471,
          name: "TotallAmount",
          visibility: true,
          width: 0,
          indexCol: 14,
          label: "کل مبلغ قرارداد",
        },
        {
          id: 204472,
          name: "NameGrpId12",
          visibility: false,
          width: 0,
          indexCol: 15,
          label: "نوع",
        },
      ],
      elmAccess: [],
      // sumTotall:0,
      // DataAxiosNew:{},
      Detail: [],
      ErrList: [],
      EditProduct: false,
      DataAxiosEditProduct: {},
      NameProductForEdit: "",
    };
  },
  components: {
    Card,
    datePicker: VuePersianDatetimePicker,
    BtnSaveData,
    SearchableCombo,
    BtnEditData,
    CardBox,
    BnpGrid,
    Modal,
  },
  computed: {
    Mab2persian() {
      return Num2persian(this.DataAxios.TotallAmount + "");
    },
  },
  methods: {
    EditRow() {
      if (this.$ValidForm("DetailCustomerProductEdit")) {
        this.DataAxiosEditProduct.TblUserGrpIdLastEdit =
          this.$session.get("UserInfo").tblUserGrpId;

        if (this.DataAxiosEditProduct.tblComboGrpId12 == 1227) {
          this.DataAxiosEditProduct.Toll = 0;
          this.DataAxiosEditProduct.Tax = 0;
          this.DataAxiosEditProduct.TotallAmount =
            this.DataAxiosEditProduct.Count * Number(this.DataAxiosEditProduct.Amount.replace(/,/g, "")) -Number(this.DataAxiosEditProduct.Discount.replace(/,/g, ""));
            

          // console.log(
          //   "😎 ~ EditRow ~ this.DataAxiosEditProduct.Discount:",
          //   this.DataAxiosEditProduct.Discount
          // );

          // console.log(
          //   "😎 ~ EditRow ~ this.DataAxiosEditProduct.Amount:",
          //   this.DataAxiosEditProduct.Amount
          // );

          // console.log(
          //   "😎 ~ EditRow ~ this.DataAxiosEditProduct.Count:",
          //   this.DataAxiosEditProduct.Count
          // );
        }
        
        let DataAxios_DeleteData = {
          ArryfildValue: this.DataAxiosEditProduct,
          Method: "post",
          Action: "CustomerProduct/EditProductOfContract",
        };
        this.$PostData(DataAxios_DeleteData)
          .then((data) => {
            if (data.status == "Ok") {
              this.$store.state.Modal = false;
              this.$mySweetDefaultTost(
                "عملیات موفق",
                "ویرایش با موفقیت انجام شد",
                "success",
                2000
              );

              let find = this.rows.find(
                (x) => x.Id == this.DataAxiosEditProduct.Id
              );

              find.Count = this.DataAxiosEditProduct.Count;
              find.Amount = this.DataAxiosEditProduct.Amount;
              find.Discount = this.DataAxiosEditProduct.Discount;
              find.Tax = this.DataAxiosEditProduct.Tax;
              find.Toll = this.DataAxiosEditProduct.Toll;
              find.NeedSubmit = this.DataAxiosEditProduct.NeedSubmit;
              find.TotallAmount = this.DataAxiosEditProduct.TotallAmount;

              let DataAxios_GetData = {
                ArryfildValue: {},
                Method: "post",
                Action: "CustomerProduct/GetProductOfContract",
                Token: this.$session.get("Token"),
              };
              DataAxios_GetData.ArryfildValue.Id = this.ContractParent.id;
              this.$PostData(DataAxios_GetData)
                .then((data) => {
                  this.rows = data;
                  this.DataAxiosProduct.TblCustomerId =
                    this.TblContract.TblCustomerId;
                  this.$SetLog(
                    this.DataAxiosEditProduct,
                    0,
                    0,
                    "CustomerProduct",
                    "محصولات قرارداد"
                  );
                })
                .finally(() => {
                  this.$store.state.renderComponentGrid = false;
                  this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true;
                  });
                });
            } else {
              this.$mySweetDefaultTost(
                "",
                "ویرایش با مشکل مواجه شد",
                "info",
                2000
              );
            }
          })
          .catch((err) => {
            console.error("CATCH", err);
            if (userIdInsert == this.userId) {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                "ارسال پیام با خطا مواجه شد",
                "error",
                2000
              );
              this.isSendingMesssage = false;
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      }
    },
    FocusOutAmountProductEdit(e) {
      console.log(this.DataAxiosEditProduct);
      this.DataAxiosEditProduct.Amount=this.$Comma3ragham(this.DataAxiosEditProduct.Amount)
      this.DataAxiosEditProduct.Discount=this.$Comma3ragham(this.DataAxiosEditProduct.Discount)
      let amount = String(this.DataAxiosEditProduct.Amount);
      var AmountProduct = Number(amount.replace(/,/g, ""));
      let discount = String(this.DataAxiosEditProduct.Discount);
      var DiscountProduct = Number(
        discount != "0" ? discount.replace(/,/g, "") : 0
      );

      if (DiscountProduct > AmountProduct * this.DataAxiosEditProduct.Count) {
        this.$mySweetDefault(
          "خطای عملیاتی",
          "مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد",
          "warning",
          1500
        );
        this.ErrList = [
          "مبلغ تخفیف وارد شده بیشتر از حد مجاز می باشد ، لطفا اصلاح نمایید و دوباره تلاش کنید",
        ];
        this.$PutCommatoInput();
        this.DataAxiosEditProduct.Discount = this.$Comma3ragham(
          AmountProduct * this.DataAxiosEditProduct.Count
        );
        return;
      } else {
        this.ErrList = [];
        var mabKol = AmountProduct * Number(this.DataAxiosEditProduct.Count) - DiscountProduct;

        if (this.DataAxiosEditProduct.tblComboGrpId12 == 1226) {
          var tax=Math.floor(this.DataAxiosEditProduct.Tax)
          var toll=Math.floor(this.DataAxiosEditProduct.Toll)
          var Sumtaxtoll=Number(tax) + Number(toll)
          this.DataAxiosEditProduct.TotallAmount = this.$Comma3ragham(Number(Math.floor( mabKol +Sumtaxtoll)));
          this.DataAxiosEditProduct.Tax = this.$Comma3ragham(
            Math.ceil(Math.floor(  Number(mabKol) * (this.DataAxiosEditProduct.ContractStartDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403) ))
          );
          this.DataAxiosEditProduct.Toll = this.$Comma3ragham(
            Math.ceil(Math.floor(  Number(mabKol) * 0.03))
          );
        } else {
          this.DataAxiosEditProduct.TotallAmount = this.$Comma3ragham(mabKol);
        }
      }
    },
    DeleteProduct(tblProductsId) {
      // console.log(this.IsRasmi);
      if (this.IsRasmi == true) {
        this.$toasted.error(
          "بعد از ثبت نهایی امکان حذف محصولات قرارداد وجود ندارد",
          { duration: 2000 }
        );
      } else {
        for (let index = 0; index < this.listProduct.length; index++) {
          if (this.listProduct[index].TblProductsId == tblProductsId) {
            this.listProduct.splice(index, 1);
          }
        }
      }
    },
    GetResulTblCostomer(data) {
      this.DataAxios.TblCustomerId = data.id;
    },
    GetResulTblCostomerProduct(data) {
      this.DataAxiosProduct["TblCustomerId"] = data.id;
    },
    GetResulProductsId(data) {
      this.DataAxios.TblProductsId = data.id;
    },
    GetResulGrpId39(data) {
      this.DataAxios.TblComboGrpId39 = 1786;
    },
    GetResulTblProductsId(data) {
      if (data.element) {
        this.DataAxiosProduct.NeedSubmit = data.element.needSubmit;
      }
      this.DataAxiosProduct["ProductName"] = data.name;
      this.DataAxiosProduct["TblProductsId"] = data.id;
    },
    AddRow(mode) {
      if (this.$ValidForm("DetailCustomerProductRow")) {
        if (mode == false) {
          if (this.rows.length == 0) {
            window.addEventListener("keydown", this.GetKeyUp);
            let SumProduct = 0;
            var findItem = false;
            for (let index = 0; index < this.listProduct.length; index++) {
              if (
                this.listProduct[index].TblProductsId ==
                this.DataAxiosProduct.TblProductsId
              ) {
                findItem = true;
                SumProduct = SumProduct + this.listProduct[index].TotallAmount;
              }
            }
            SumProduct = this.DataAxiosProduct.TotallAmount;
            if (findItem == false) {
              if (
                this.TblContract &&
                Number(SumProduct.replace(/,/g, "")) <
                  Number(this.TblContract.TotallAmount)
              ) {
                //رسمی
                this.DataAxiosProduct.TblUserGrpIdInsert =
                  this.$session.get("UserInfo").tblUserGrpId;
                this.listProduct.push(
                  JSON.parse(JSON.stringify(this.DataAxiosProduct))
                );
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "آیتم مورد نظر شما به لیست محصولات اضافه گردید ",
                  "success",
                  1000
                );
                this.ReloadProduct();
                this.AddModeProduct = 0;
                return;
              } else if (!this.TblContract) {
                //غیر رسمی
                this.DataAxiosProduct.TblUserGrpIdInsert =
                  this.$session.get("UserInfo").tblUserGrpId;
                this.listProduct.push(
                  JSON.parse(JSON.stringify(this.DataAxiosProduct))
                );
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "آیتم مورد نظر شما به لیست محصولات اضافه گردید ",
                  "success",
                  1000
                );
                this.ReloadProduct();
                this.AddModeProduct = 0;
                return;
              } else {
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  "جمع مبالغ محصولات با جمع مبلغ قرارداد یکسان نمی باشد",
                  "success",
                  1000
                );
                return;
              }
            } else {
              this.$mySweetDefault(
                "عملیات ناموفق",
                "آیتم مورد نظر شما در لیست محصولات وجود دارد",
                "error",
                1500
              );
              return;
            }
          } else {
            this.$mySweetDefault(
              "خطای عملیاتی",
              "امکان اضافه کردن محصول جدید به قراردادی که قبلا ثبت کامل شده امکان پذیر نمی باشد ، لطفا در قرارداد جدید محصول خودرا اضافه کنید",
              "error",
              6000
            );
          }
        }
      }
    },
    ReloadProduct() {
      // this.DataAxiosProduct={}
      var temp = JSON.parse(
        JSON.stringify(this.DataAxiosProduct.TblCustomerId)
      );
      this.DataAxiosProduct = JSON.parse(
        JSON.stringify(this.DataAxiosProductnew)
      );
      this.DataAxiosProduct.TblCustomerId = temp;
    },
    FocusOutAmountProduct(e) {
      console.log('FocusOutAmountProduct');
      var AmountProduct = Number(
        this.DataAxiosProduct.Amount.replace(/,/g, "")
      );
      var DiscountProduct = Number(
        this.DataAxiosProduct.Discount != "0"
          ? this.DataAxiosProduct.Discount.replace(/,/g, "")
          : 0
      );

      if (DiscountProduct > AmountProduct * this.DataAxiosProduct.Count) {
        this.$mySweetDefault(
          "خطای عملیاتی",
          "مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد",
          "warning",
          1500
        );
        this.ErrList = [
          "مبلغ تخفیف وارد شده بیشتر از حد مجاز می باشد ، لطفا اصلاح نمایید و دوباره تلاش کنید",
        ];
        this.$PutCommatoInput();
        this.DataAxiosProduct.Discount = this.$Comma3ragham(
          AmountProduct * this.DataAxiosProduct.Count
        );
        return;
      } else {
        this.ErrList = [];
        var mabKol =
          AmountProduct * Number(this.DataAxiosProduct.Count) - DiscountProduct;
        this.DataAxiosProduct.Tax = this.$Comma3ragham(
          Math.ceil(Number(mabKol) * 0.07)
        );
        this.DataAxiosProduct.Toll = this.$Comma3ragham(
          Math.ceil(Number(mabKol) * 0.03)
        );

        this.DataAxiosProduct.TotallAmount =
          mabKol == 0
            ? 0
            : this.$Comma3ragham(
                mabKol +
                  Number(this.DataAxiosProduct.Tax.replace(/,/g, "")) +
                  Number(this.DataAxiosProduct.Toll.replace(/,/g, ""))
              );
      }
    },
    FocusOutAmount(e) {
      console.log('FocusOutAmount');
      var Amount = Number(this.DataAxios.Amount.replace(/,/g, ""));
      var Discount = Number(
        this.DataAxios.Discount != "0"
          ? this.DataAxios.Discount.replace(/,/g, "")
          : 0
      );
      if (Discount >= Amount) {
        this.$mySweetDefault(
          "خطای عملیاتی",
          "مبلغ تخفیف نمیتواند بیشتر از مبلغ محصول باشد",
          "warning",
          1500
        );
        return;
      } else {
        var mabKol = Amount - Discount;
        this.DataAxios.Tax = this.$Comma3ragham(Number(mabKol) * 0.07);
        this.DataAxios.Toll = this.$Comma3ragham(Number(mabKol) * 0.03);
        this.DataAxios.TotallAmount = this.$Comma3ragham(
          mabKol +
            Number(this.DataAxios.Tax.replace(/,/g, "")) +
            Number(this.DataAxios.Toll.replace(/,/g, ""))
        );
      }
    },
    CheckLenghtDiscount(e, IsProduct) {
      if (IsProduct == true) {
        if (e.target.value.length < 4 && e.target.value.length > 0) {
          this.DataAxiosProduct.DiscountProduct = 0;
          this.FocusOutAmountProduct();
        }
      }
      if (IsProduct == false) {
        if (e.target.value.length < 4 && e.target.value.length > 0) {
          this.DataAxios.Discount = 0;
          this.FocusOutAmount();
        }
      }
    },
    submitProduct() {
      var Contract = {
        Id: 1,
        TblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
        TblComboGrpId12: 1227,
        TblCustomerId: this.listProduct[0].TblCustomerId,
        ContractStartDate: "",
        ContractEndDate: "",
        TblComboGrpId39: 1787,
        Amount: 0,
        Discount: 0,
        Tax: 0,
        Toll: 0,
        TotallAmount: 0,
      };
      if (this.TblContract != null) {
        Contract = this.TblContract;
      }
      Contract["TblCustomerProducts"] = this.listProduct;
      var DataAxios_Post = {
        Action: "CustomerProduct",
        Method: "Post",
        Token: this.$session.get("Token"),
        ArryfildValue: {},
      };
      DataAxios_Post.ArryfildValue = Contract;
      this.$PostData(DataAxios_Post)
        .then((result) => {
          if (result.status == "Ok") {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "محصول جدید با موفقیت ثبت شد",
              "success",
              3000
            );
            this.$router.push({
              name: "Contract",
              params: { TblCustomerId: this.listProduct[0].TblCustomerId },
            });
            this.listProduct = [];
          }
        })
        .finally(() => {});
    },
    submitProductContract(isRasmi) {
      let SumAmount = 0;
      let SumDiscount = 0;
      let SumToll = 0;
      let SumTax = 0;
      let SumTotall = 0;
      let TblCustomerId = null;
      this.listProduct.forEach((e) => {
        // console.log(e);
        if (this.tempFactoToContract) {
          SumAmount =
            Math.floor(SumAmount) + Math.floor(e.Amount) * Math.floor(e.Count);
          e.Discount = Math.floor(e.Discount);
          SumDiscount = Math.floor(SumDiscount) + Math.floor(e.Discount);
          SumToll = Math.floor(SumToll) + Math.floor(e.Toll);
          SumTax = Math.floor(SumTax) + Math.floor(e.Tax);

          SumTotall = Math.floor(SumTotall) + Math.floor(e.TotallAmount);
          TblCustomerId = e.TblCustomerId;
        } else {
          SumAmount = +SumAmount + Number(e.Amount.replace(/,/g, "")) * e.Count;
          e.Discount = e.Discount + "";
          SumDiscount = +SumDiscount + Number(e.Discount.replace(/,/g, ""));
          SumToll =
            +SumToll +
            (typeof e.Toll === "string"
              ? Number(e.Toll.replace(/,/g, ""))
              : e.Toll);
          SumTax =
            +SumTax +
            (typeof e.Tax === "string"
              ? Number(e.Tax.replace(/,/g, ""))
              : e.Tax);
          SumTotall =
            +SumTotall +
            (typeof e.TotallAmount === "string"
              ? Number(e.TotallAmount.replace(/,/g, ""))
              : e.TotallAmount);
          TblCustomerId = e.TblCustomerId;
        }
      });
      var today = this.$store.state.JalaliDate;
      var nextyear = Number(today.substring(0, 4)) + 1 + today.substring(4);
      var Contract = {
        Id: 1,
        TblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
        TblComboGrpId12: isRasmi ? 1226 : 1227,
        TblCustomerId: TblCustomerId,
        ContractStartDate: today,
        ContractEndDate: nextyear,
        TblComboGrpId39: 1787,
        Amount: this.$Comma3ragham(SumAmount),
        Discount: this.$Comma3ragham(SumDiscount),
        Tax: isRasmi ? this.$Comma3ragham(SumTax) : 0,
        Toll: isRasmi ? this.$Comma3ragham(SumToll) : 0,
        TotallAmount: isRasmi
          ? this.$Comma3ragham(SumTotall)
          : this.$Comma3ragham(SumAmount - SumDiscount),
      };
      this.DataAxios = Contract;
      this.IsRasmi = true;
      this.AddModeContract = 1;
      this.Disable = true;
    },
    SetContrctAndProducts() {
      if (this.DataAxios.ContractStartDate == this.DataAxios.ContractEndDate) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "تاریخ شروع و پایان قرارداد نمیتواند یکسان باشد. ",
          "warning",
          1000
        );
        return 0;
      }
      if (this.$ValidForm("DivContract")) {
        this.DataAxios["TblCustomerProducts"] = this.listProduct;
        var DataAxios_Post = {
          Action: "CustomerProduct",
          Method: "Post",
          Token: this.$session.get("Token"),
          ArryfildValue: {},
        };
        this.DataAxios.TblComboGrpId39 = 1786;
        if (this.TblCustomerId && this.TblContract) {
          this.DataAxios.Id = this.TblContract.Id;
        }

        DataAxios_Post.ArryfildValue = this.DataAxios;
        this.$PostData(DataAxios_Post)
          .then((result) => {
            if (result.status == "Ok") {
              this.$toasted.success("ثبت قرارداد با موفقیت انجام شد .", {
                duration: 3000,
              });
              this.$SweetQustion(
                "ثبت موفق",
                "قرارداد با موفقیت ثبت شد. آیا مایلید فاکتور صادر کنید؟",
                "success",
                "ثبت فاکتور قرارداد",
                "بازگشت به صفحه مشتری",
                result,
                this.ToFactor,
                this.ToCustomer
              );
            }
          })
          .finally(() => {});
      }
    },
    ToCustomer() {
      this.$router.push({
        name: "DetailCustomer",
        params: {
          tblCustomerId: this.listProduct[0].TblCustomerId,
          activeTab: 11,
        },
      });
      this.listProduct = [];
      this.IsRasmi = false;
    },
    ToFactor(data) {
      var ToFacrotList = [];
       console.log(data);
      data.detail.forEach((ele) => {
        ToFacrotList.push({
          Id: ele.tcp.id,
          TblCustomerId: ele.tcp.tblCustomerId,
          TblProductsId: ele.tcp.tblProductsId,
          TblContractId: ele.tcp.tblContractId,
          Amount: ele.tcp.amount,
          Discount: ele.tcp.discount,
          Count: ele.tcp.count,
          Tax: ele.tcp.tax,
          Toll: ele.tcp.toll,
          TotallAmount: ele.tcp.totallAmount,
          NeedSubmit: ele.tcp.needSubmit,
          Rate: ele.tcp.rate,
          TblComboGrpId39: ele.tcp.tblComboGrpId39,
          Grp39Name: "",
          CustomerName: "",
          ProductName: ele.name,
          IsRasmi: data.contract.tblComboGrpId12 == 1226,
          contractStartDate : ele.tcp.tblContract.contractStartDate,
        });
      });
      this.$router.push({
        name: "Factor",
        params: { Status: "Add", propstblCustomerProducts: ToFacrotList },
      });
      this.listProduct = [];
      this.IsRasmi = false;
    },
    GotoContract(TblCustomerId) {
      if (this.IsCartableContract)
        this.$router.push({ name: "CartableContract" });
      else
        this.$router.push({
          name: "Contract",
          params: { TblCustomerId: TblCustomerId },
        });
    },
    OnEditProduct(row) {
      this.NameProductForEdit = row.Name;
      this.DataAxiosEditProduct = row;

      // this.DataAxiosEditProduct.Id = row.Id;
      // this.DataAxiosEditProduct.Count = row.Count;
      // this.DataAxiosEditProduct.Amount = row.Amount;
      // this.DataAxiosEditProduct.Discount = row.Discount;
      // this.DataAxiosEditProduct.Tax = row.Tax;
      // this.DataAxiosEditProduct.TotallAmount = row.TotallAmount;
      // this.DataAxiosEditProduct.Toll = row.Toll;
      // this.DataAxiosEditProduct.NeedSubmit = row.NeedSubmit;
      // this.DataAxiosEditProduct.TblContractId = row.TblContractId;

      this.$store.state.Modal = true;
      let find = this.rows.find((x) => x.Id == row.Id);
      this.$store.state.OldDataForLog = JSON.stringify(find);
    },
    OnDeleteProduct(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row);
      let DataAxios_DeleteData = {
        ArryfildValue: row,
        Method: "delete",
        Action: "CustomerProduct",
        Token: this.$session.get("Token"),
      };
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mx-1",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "اطمینان دارید؟",
          text: "از حذف محصول " + row.Name + " ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "بله، حذف شود",
          cancelButtonText: "لغو",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$PostData(DataAxios_DeleteData)
              .then((data) => {
                if (data.status == "Ok") {
                  let DataAxios_GetData = {
                    ArryfildValue: {},
                    Method: "post",
                    Action: "CustomerProduct/GetProductOfContract",
                    Token: this.$session.get("Token"),
                  };
                  DataAxios_GetData.ArryfildValue.Id = this.ContractParent.id;
                  this.$PostData(DataAxios_GetData)
                    .then((data) => {
                      this.rows = data;
                      this.DataAxiosProduct.TblCustomerId =
                        this.TblContract.TblCustomerId;
                      this.$toasted.success("حذف با موفقیت صورت گرفت", {
                        action: {
                          text: "بستن",
                          onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                          },
                        },
                      });
                      this.$SetLog(
                        DataAxios_DeleteData.ArryfildValue,
                        1,
                        0,
                        "CustomerProduct",
                        "محصولات قرارداد"
                      );
                    })
                    .finally(() => {
                      this.$store.state.renderComponentGrid = false;
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true;
                      });
                    });
                } else if (data.status == "Not Ok") {
                  this.$toasted.error("حذف با خطا مواجه شد ، " + data.msg, {});
                } else {
                  if (data.eNum == 547) {
                    this.$mySweetDefaultTost(
                      "عملیات ناموفق",
                      "امکان حذف محصول فروخته شده به دلیل  وجود سند واریزی برای این محصول امکان پذیر نمی باشد",
                      "warning",
                      5000
                    );
                  }
                }
              })
              .finally(() => {
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true;
                });
              });
          }
        });
    },
    GetKeyUp(e) {
      if (e.which === 114) {
        e.preventDefault(); //prevent browser from the default behavior
        if (this.IsAccess("btnSetContract!Rasmi")) {
          this.submitProductContract(false);
        }
      }
    },
    GetAccessUser() {
      var menu = this.$session.get("Menu");
      var IdMenu = menu.find((x) => x.RouteName == this.$route.name).id;
      this.elmAccess = menu.filter((x) => x.ParentId == IdMenu);
    },
    IsAccess(elmId) {
      let IsExist = false;
      this.elmAccess.forEach((element) => {
        if (element.ControlName == elmId) {
          if (element.isMojaz == 1) {
            IsExist = true;
          }
        }
      });
      return IsExist;
    },
    CalcBedehiCustomer(TblCustomerId) {
      this.$CalcBedehiCustomer(TblCustomerId).then((result) => {
        this.Detail = result[0];
      });
    },
    SetDeposit() {
      this.$router.push({
        name: "Deposit",
        params: {
          Status: "Add",
          TblCustomerId: this.ContractParent.TblCustomerId,
        },
      });
    },
    generateContractFromTemp() {
      var dataAxiosGetTempFactor = {
        Action: "TempFactor/GetById",
        Method: "POST",
        ArryfildValue: { Id: this.tempFactoToContract },
      };
      this.$PostData(dataAxiosGetTempFactor).then((result) => {
        if (result.status != "success") {
          this.$mySweetDefaultTost("خطا", "پیش فاکتور پیدا نشد", "error", 2000);
        } else {
          console.log(result);
          result.tempFactorDetail.forEach((element) => {
            this.listProduct.push({
              Id: 1,
              Count: element.count,
              DataAxiosProduct: 0,
              Discount: element.discount,
              Tax: result.tempFactor.isRasmi
                ? (element.amount * element.count - element.discount) * (result.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403) 
                : 0,
              TotallAmount: Math.floor(
                result.tempFactor.isRasmi
                  ? (element.amount * element.count - element.discount) * (result.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? 1.09 : 1.1)
                  : element.amount * element.count - element.discount
              ),
              Toll: result.tempFactor.isRasmi
                ? (element.amount * element.count - element.discount) * 0.03
                : 0,
              TblCustomerId: result.tempFactor.tblCustomerId,
              ProductName: element.nameProduct,
              TblProductsId: element.tblProductsId,
              Amount: element.amount,
              NeedSubmit: element.needSubmit,
              TblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
            });
          });

          this.submitProductContract(result.tempFactor.isRasmi);
        }
      });
    },
  },
  mounted() {
    this.GetAccessUser();
    this.DataAxios.TblUserGrpIdInsert =
      this.$session.get("UserInfo").tblUserGrpId;
    this.DataAxios.TblComboGrpId12 = 1226;
    // this.DataAxiosProduct.TblCustomerId= this.TblCustomerId
  },
  created() {
    this.DataAxiosProduct = JSON.parse(
      JSON.stringify(this.DataAxiosProductnew)
    );
    if (this.$route.params.Status == "Add") {
      this.ContractParent = this.TblContract;
      if (this.TblCustomerId && this.TblContract) {
        this.DataAxiosProduct.TblCustomerId = this.TblCustomerId;
        this.AddModeProduct = 1;
        this.DataAxios = this.TblContract;
      }
      if (this.TblCustomerId && !this.TblContract) {
        this.DataAxiosProduct.TblCustomerId = this.TblCustomerId;
        this.AddModeProduct = 1;
      }

      if (this.tempFactoToContract) {
        this.generateContractFromTemp();
      }
    }
    if (this.Status == "Product") {
      this.IsRasmi = false;
      this.ContractParent = this.TblContract;
      let DataAxios_GetData = {
        ArryfildValue: {},
        Method: "post",
        Action: "CustomerProduct/GetProductOfContract",
        Token: this.$session.get("Token"),
      };
      DataAxios_GetData.ArryfildValue.Id = this.ContractParent.id
        ? this.ContractParent.id
        : this.ContractParent.Id;
      this.$PostData(DataAxios_GetData)
        .then((data) => {
          this.rows = data;
          this.DataAxiosProduct.TblCustomerId = this.TblContract.TblCustomerId;
          this.CalcBedehiCustomer(this.TblContract.TblCustomerId);
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    }
    if (this.$route.params.Status == "Edit") {
      this.DataAxios = this.TblContract;
      this.DataAxios.Amount = this.$Comma3ragham(this.TblContract.Amount);
      this.DataAxios.Toll = this.$Comma3ragham(this.TblContract.Toll);
      this.DataAxios.TotallAmount = this.$Comma3ragham(
        this.TblContract.TotallAmount
      );
      this.DataAxios.Tax = this.$Comma3ragham(this.TblContract.Tax);
      this.DataAxios.Discount = this.$Comma3ragham(this.TblContract.Discount);
      this.AddModeContract = 1;
      this.IsRasmi = true;
      this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios);
    }
  },
  props: [
    "TblContract",
    "IsAccessDelete",
    "IsAccessSetDeposit",
    "TblCustomerId",
    "IsCartableContract",
    "Status",
    "tempFactoToContract",
  ],
  updated() {
    this.$PutCommatoInput();
  },
};
</script>
<style scoped>
.rubber_stamp {
  font-family: "IRANSansWeb", sans-serif;
  font-size: 39px;
  line-height: 45px;
  text-transform: uppercase;
  font-weight: bold;
  color: rgb(102, 184, 20);
  border: 7px solid rgb(102, 184, 20);
  float: left;
  padding: 10px 7px;
  border-radius: 10px;

  opacity: 0.6;
  -webkit-transform: rotate(-10deg);
  -o-transform: rotate(-10deg);
  -moz-transform: rotate(-10deg);
  -ms-transform: rotate(-10deg);
  position: absolute;
  top: 90%;
  z-index: 100;
}
.rubber_stamp::after {
  position: absolute;
  content: " ";
  width: 100%;
  height: auto;
  min-height: 100%;
  top: -10px;
  left: -10px;
  padding: 10px;
  /* background: url(https://raw.github.com/domenicosolazzo/css3/master/img/noise.png) repeat; */
}
</style>
